<template>
  <v-container class="background pa-0">
    <edit-question-form
      :question="edit_question"
      v-on:cancel="edit_question = null"
      v-on:save="handleSave"
      v-if="edit_question != null"
      :featureId="featureId"
    ></edit-question-form>
    <edit-pulse-sub-category-form
      :subCategory="edit_sub_category"
      v-on:cancel="edit_sub_category = null"
      v-on:save="edit_sub_category = null"
      v-else-if="edit_sub_category != null"
    ></edit-pulse-sub-category-form>
    <template v-else>
      <template v-if="category.questions.length == 0">
        <v-img :src="$images.CORE_CARD_NO_DATA" class="ma-4"></v-img>
        <div class="text-h4 text-center">This Category Needs Questions</div>
        <div class="subtitle-1 text-center">
          No questions have been created here yet
        </div>
      </template>
      <template v-for="(question, i) in category.questions">
        <v-row :key="i" class="pl-16 pr-8">
          <v-col cols="12" class="pb-0" v-if="subCategoryText(question)">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-chip color="accent" outlined v-bind="attrs" v-on="on">
                  {{ subCategoryText(question) }}
                </v-chip>
              </template>
              <div class="tooltip-limit-width">
                {{
                  (question.subCategory || { description: "" }).description ||
                    (question.relatedItem || { description: "" }).description
                }}
              </div>
            </v-tooltip>
            <v-btn
              color="info"
              text
              v-if="question.relatedId"
              :to="`/corevalues/${question.relatedId}`"
            >
              Manage value
            </v-btn>
            <v-btn
              color="info"
              text
              v-if="question.subCategory && question.subCategory.companyId"
              @click="edit_sub_category = question.subCategory"
            >
              Edit
            </v-btn>
          </v-col>
          <v-col class="subtitle-1">
            {{ question.question }}
            <div class="caption" v-if="question.questionTypeId">
              <v-icon :color="getColor(question)" small class="mr-2">
                {{ getIcon(question) }}
              </v-icon>
              <span
                v-bind:style="{
                  color: getColor(question)
                }"
              >
                {{ getQuestionType(question) }}
              </span>
            </div>
          </v-col>
          <v-spacer class="limited-spacer"></v-spacer>
          <v-col cols="auto" class="my-auto">
            <v-switch
              v-model="question.isEnabled"
              color="success"
              hide-details
              class="my-0"
              @change="toggleQuestion(question)"
            ></v-switch>
          </v-col>
          <v-col cols="auto" class="my-auto px-0">
            <v-menu absolute v-if="question.companyId != null">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="edit_question = _.cloneDeep(question)">
                  <v-list-item-icon>
                    <v-icon>edit</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteQuestion(question)">
                  <v-list-item-icon>
                    <v-icon>delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-tooltip v-else top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on">
                  lock
                </v-icon>
              </template>
              <span class="pa-2">
                Created By CoreCounts - Can't edit or delete
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-divider
          :key="i + 'divider'"
          v-if="i != category.questions.length - 1"
        ></v-divider>
      </template>
      <template v-if="!category.locked">
        <v-divider></v-divider>
        <v-row class="pl-16 pr-8">
          <v-col cols="12">
            <v-btn
              color="performance"
              text
              v-if="!settings.isNonLitePlan"
              @click="$router.push({ path: '/billing' })"
            >
              Upgrade to add your own question >
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              @click="
                edit_question = {
                  categoryId: category.id,
                  isEnabled: true,
                  subCategory: {}
                }
              "
              v-else
            >
              <v-icon class="mr-2">add_circle</v-icon>
              New Question
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import questionTypes from "@/helpers/mixins/questionTypes";
import EditQuestionForm from "@/components/questions/EditQuestionForm";
import EditPulseSubCategoryForm from "@/components/pulse/EditPulseSubCategoryForm";
export default {
  name: "QuestionList",
  components: { EditQuestionForm, EditPulseSubCategoryForm },
  mixins: [questionTypes],
  props: { featureId: { type: Number }, category: { type: Object } },
  data: () => ({
    dialog: false,
    saving: false,
    edit_question: null,
    edit_sub_category: null
  }),
  watch: {},
  computed: {
    subCategoryText() {
      return question => {
        return (
          (question.subCategory || { name: "" }).name ||
          (question.relatedItem || { name: "" }).name
        );
      };
    },
    categories() {
      return this.$store.getters[this.categoriesGetter];
    },
    categoriesGetter() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "pulse/categories";
        case this.$enums.features.REVIEW:
          return "settings/review_categories";
      }
      return "";
    },
    toggleAction() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "pulse/toggleQuestion";
        case this.$enums.features.REVIEW:
          return "settings/toggleReviewQuestion";
      }
      return "";
    },
    deleteAction() {
      switch (this.featureId) {
        case this.$enums.features.PULSE:
          return "pulse/deleteQuestion";
        case this.$enums.features.REVIEW:
          return "settings/deleteReviewQuestion";
      }
      return "";
    },
    ...mapGetters({
      survey_question_types: "lookup/survey_question_types",
      settings: "profile/settings"
    })
  },
  methods: {
    handleSave() {
      // if (this.category.questions.indexOf(x => x.id == questionId) < 0) {
      //   let newQuestion = (
      //     (this.categories.find(x => x.id == this.category.id) || {})
      //       .questions || []
      //   ).find(x => x.id == questionId);
      //   if (newQuestion) {
      //     newQuestion.isEnabled = true;
      //     this.category.questions.push(newQuestion);
      //   }
      // }
      this.edit_question = null;
    },
    getQuestionType(question) {
      let list = this.survey_question_types
        .filter(x => x.id == question.questionTypeId)
        .map(x => x.name);

      if (list.length > 0) {
        return list[0];
      }
      return "";
    },
    getIcon(question) {
      return this.getQuestionTypeIcon(question.questionTypeId);
    },
    getColor(question) {
      return this.getQuestionTypeColor(question.questionTypeId);
    },
    cancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    toggleQuestion(question) {
      this.$store
        .dispatch(this.toggleAction, {
          id: question.id,
          isEnabled: question.isEnabled || false
        })
        .then(() => {
          this.$root.$snackbarSuccess("Question updated");
        })
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while saving question"
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // save() {
    //   this.saving = true;
    //   this.$store
    //     .dispatch(this.toggleAction, this.category)
    //     .then(() => {
    //       this.$emit("save");
    //       this.$root.$snackbarSuccess("Questions updated");
    //       this.dialog = false;
    //     })
    //     .catch(error => {
    //       this.logError(error);
    //       this.$root.$alert(
    //         "Error Occurred",
    //         "An error occurred while saving your questions."
    //       );
    //     })
    //     .finally(() => {
    //       this.saving = false;
    //     });
    // },
    async deleteQuestion(question) {
      if (
        await this.$root.$confirm(
          "Delete question",
          "Are you sure you want to delete this question?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch(this.deleteAction, question)
          .then(() => {
            this.$root.$snackbarSuccess("Question deleted");
            this.dialog = false;
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting a question."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .v-card__text {
  max-height: 500px;
  overflow-y: scroll;
}
</style>
